import * as React from 'react';

import { createClient, type Client } from '@connectrpc/connect';
import { PrinterLocalService } from '@rematter/frontend-lib-api-client/grpc/sidecar/v1/printer_local_api_pb';

import { useLibp2p } from './useLibp2p';

export type PrinterLocalClient = Client<typeof PrinterLocalService>;

export function usePrinterLocalClient(
  sidecarId: string,
): PrinterLocalClient | null {
  const { getTransport, connections } = useLibp2p();

  const isConnected = connections.get(sidecarId)?.connected ?? false;

  return React.useMemo(() => {
    if (!isConnected) return null;

    const transport = getTransport(sidecarId);
    if (!transport) return null;

    return createClient(PrinterLocalService, transport);
  }, [sidecarId, getTransport, isConnected]);
}
